import { LegalDocument } from '@/legal/components/LegalDocument';
import content from '@/legal/content/terms-ru-v1.0.md?raw';

export function TermsOfUsePage() {
  return (
    <LegalDocument
      title="Условия использования"
      content={content}
      version="1.0"
      effectiveDate="2026-05-07"
      readingMinutes={22}
      jurisdictions={['ru', 'eu', 'us']}
    />
  );
}
